import { EditOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { Fragment, h } from "preact";
import { TagCompoent } from "../../../components/tag/styled";
import { Text } from "../../../components/text";
import { getPropertiesStatus } from "../../../functions";
import { Center } from "../../../style/styled";
import { IColumnPreview } from "../interfaces/table";
import { color } from "../../../resources";

export const COULMN_PREVIEW = (): IColumnPreview[] => [
  {
    title: "ลำดับ",
    dataIndex: "index",
    key: "index",
    width: "0.5em",
  },
  {
    title: "หมายเลขเครื่องตัด",
    dataIndex: "deviceID",
    key: "deviceID",
    width: "10em",
    render: (text, _record) => {
      console.log(_record);
      return (
        <Text
          size={"S"}
          text={text as string}
          color={_record.error ? "red" : ""}
        />
      );
    },
  },
  {
    title: "ลักษณะเครื่อง",
    dataIndex: "deviceType",
    key: "deviceType",
    width: "12em",
  },
  {
    title: "ขนาดเครื่อง",
    dataIndex: "deviceSize",
    key: "deviceSize",
    width: "8em",
  },
  {
    title: "ข้อผิดพลาด",
    dataIndex: "error",
    key: "error",
    width: "15em",
    fixed: "right",
  },
];

export const COULMN_DATA = (props?: any): IColumnPreview[] => [
  {
    title: "ลำดับ",
    dataIndex: "index",
    key: "index",
    width: "4em",
  },
  {
    title: "หมายเลขเครื่องตัด",
    dataIndex: "deviceID",
    key: "deviceID",
    width: "10em",
    render: (text) => {
      return <Text size={"S"} text={text as string} bold={true} />;
    },
  },
  {
    title: "หมายเลขรหัส PL",
    dataIndex: "deviceLotID",
    key: "deviceLotID",
    width: "10em",
  },
  {
    title: "รหัสลูกค้า",
    dataIndex: "customerCode",
    key: "customerCode",
    width: "10em",
  },
  {
    title: "ลักษณะเครื่อง",
    dataIndex: "deviceType",
    key: "deviceType",
    width: "15em",
  },
  {
    title: "ขนาดเครื่อง",
    dataIndex: "deviceSize",
    key: "deviceSize",
    width: "8em",
  },
  {
    title: "วันที่สร้าง",
    dataIndex: "createDate",
    key: "createDate",
    width: "12em",
  },
  {
    title: "ผู้ที่สร้าง",
    dataIndex: "userCreate",
    key: "userCreate",
    width: "8em",
  },
  {
    title: "Bluetooth",
    dataIndex: "bluetooth",
    key: "bluetooth",
    width: "5em",
  },
  {
    title: "Proxy",
    dataIndex: "proxy",
    key: "proxy",
    width: "5em",
  },
  {
    title: "Group",
    dataIndex: "groupName",
    key: "groupName",
    width: "5em",
  },
  {
    title: "Version",
    dataIndex: "version",
    key: "version",
    width: "7em",
  },
  {
    title: "Lot/เดือน",
    dataIndex: "lotMonth",
    key: "lotMonth",
    width: "7em",
    render: (text: any) => {
      if (!text) return <Text size={"S"} text={"-"} />;
      return <Text size={"S"} text={text} />;
    },
  },
  {
    title: "หมายเหตุ",
    dataIndex: "remark",
    key: "remark",
    width: "20em",
  },
  {
    title: "เปิด-ปิด",
    dataIndex: "isAvailable",
    key: "isAvailable",
    width: "5em",
    render: (r: any) => {
      const text = r ? "เปิด" : "ปิด";
      const cl = r ? color.green : color.menu;

      return (
        <Center>
          <TagCompoent color={cl}>{text}</TagCompoent>
        </Center>
      );
    },
  },
  {
    title: "สถานะ",
    dataIndex: "deviceStatusId",
    key: "deviceStatusId",
    width: "10em",
    fixed: "right",
    render: (r: any) => {
      const { color, text: t } = getPropertiesStatus(r as string);
      return (
        <Center>
          <TagCompoent color={color}>{t}</TagCompoent>
        </Center>
      );
    },
  },
  {
    title: "สถานะเครื่อง",
    dataIndex: "extDeviceStatus",
    key: "extDeviceStatus",
    width: "8em",
    fixed: "right",
    render: (r: any) => {
      if (!r) return <Text size={"S"} text={"-"} />;
      const { color: c, text: t } = getPropertiesStatus(r as string);
      return (
        <Center>
          <TagCompoent color={c}>{t}</TagCompoent>
        </Center>
      );
    },
  },
  {
    title: "",
    key: "button",
    width: "10em",
    fixed: "right",
    render: (record) => {
      return (
        <>
          <Button
            onClick={() => props.onEdit(record)}
            type="primary"
            shape="circle"
            icon={(<EditOutlined />) as React.ReactNode}
            style={{ marginRight: 10 }}
          />
        </>
      );
    },
  },
];
